import React from "react";
import { Table, Button } from "antd";
import rolesDictionary from "../../config/rolesDictionary";
import moment from "moment";
import { Excel } from "antd-table-saveas-excel";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const ListLogs = (props) => {
  const handleClick = () => {
    const excel = new Excel();
    excel
      .addSheet("report")
      .addColumns(logColumns)
      .addDataSource(logs, {
        str2Percent: true,
      })
      .saveAs("report.xlsx");
  };
  const logColumns = [
    {
      title: "Огноо",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (_, record) =>
        record?.createdAt
          ? moment(record?.createdAt).format("YYYY-MM-DD HH:mm:ss")
          : "-",
    },
    {
      title: "Захиалгын дугаар",
      dataIndex: "note",
      key: "note",
    },

    {
      title: "Захиалгын төрөл",
      dataIndex: "eventCode",
      key: "eventCode",
      render: (_, record) =>
        record?.eventCode === "procurement"
          ? "Татан авалт"
          : record?.eventCode === "delivery"
          ? "Хүргэлт"
          : record?.eventCode === "cancel"
          ? "Цуцалсан"
          : record?.eventCode === "return"
          ? "Буцаалт"
          : "",
    },
    {
      title: "Тоо хэмжээ",
      dataIndex: "numberValue",
      key: "numberValue",
      render: (_, record) =>
        record?.eventCode === "procurement"
          ? `+${record.numberValue}`
          : record?.eventCode === "delivery"
          ? `-${record.numberValue}`
          : record?.eventCode === "return"
          ? `+${record.numberValue}`
          : "",
    },
    {
      title: "Үлдэгдэл",
      dataIndex: "totalStock",
      key: "totalStock",
    },
    {
      title: "Роль",
      dataIndex: "hubmanRole",
      key: "hubmanRole",
      render: (_, record) => showRoleCode(record),
    },
    {
      title: "Өөрчилсөн",
      dataIndex: "userName",
      key: "userName",
    },
  ];
  const logs = props.location.state;
  const showRoleCode = (event) => {
    const matchedCode = rolesDictionary.rolesDictionary.find(
      (role) => role.roleCode === event.hubmanRole
    );
    if (matchedCode) {
      return matchedCode.name;
    } else return "-";
  };
  return (
    <>
      <div className="product__detail__info">
        <div
          className={"product__log__header__sticky"}
          style={{ padding: "25px 25px 25px 25px" }}
        >
          <div style={{ display: "flex", fontSize: "20px" }}>
            <Link
              to="/merchant/product/list"
              style={{ marginRight: "20px", marginTop: "10px" }}
            >
              <ArrowLeftOutlined style={{ color: "#08c" }} />
            </Link>
            <h2>Өөрчлөлтийн түүх</h2>
          </div>
        </div>
        <Button type="primary" onClick={handleClick} style={{ margin: 10 }}>
          Export
        </Button>
        <div style={{ padding: 10 }}>
          <Table dataSource={logs} columns={logColumns} />
        </div>
      </div>
    </>
  );
};

export default ListLogs;
